import { createRouter, createWebHistory } from "vue-router";
import Home from "./App.vue";

// 定义路由
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    props: (route) => ({
      start_date: route.query.start_date || null,
      end_date: route.query.end_date || null,
    }),
  },
];

// 创建路由实例
const router = createRouter({
  // 使用 HTML5 History 模式
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
